import React from 'react';
import {ShowIf} from 'components/utils';

class SupportBusiness extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [
        {
          img: 'CRM.svg',
          title: 'Hệ thống CMR',
          content: 'Giảm 20% chi phí sử dụng',
          description: 'trong năm đầu tiên'
        },
        {
          img: 'Tri_Tue.svg',
          title: 'Đăng ký nhãn hiệu - Sở hữu trí tuệ',
          content: 'Giảm 30% chi phí'
        },
        {
          img: 'Ung_Dung.svg',
          title: 'Đăng ký khóa học đồ họa ứng dụng',
          content: 'Giảm 20% chi phí'
        },
        {
          img: 'Kovo.svg',
          title: 'Thiết kế website',
          content: 'Giảm 30% chi phí'
        },
        {
          img: 'San_Pham.svg',
          title: 'Thiết kế bao bì sản phẩm',
          content: 'Giảm 15% chi phí'
        },
        {
          img: 'Sapo.svg',
          title: 'Tạo web từ hệ thống',
          content: 'Giảm 20% chi phí'
        }
      ]
    };
  }

  render() {
    console.log(this.state);
    return (
      <section className="support-business-wrap">
        {
          this.state.data.map((item, index) => {
            return (
              <div className="block-support-business" key={index}>
                <img className="support-business-img" src={require(`assets/images/support-business/${item.img}`)}/>
                <div className="support-business-content">
                  <span className="title">{item.title}</span>
                  <span className="content">{item.content}</span>
                  <ShowIf condition={item.description}>
                    <span className="description">{item.description}</span>
                  </ShowIf>
                </div>
                <div className="support-business-box-redirect">
                  <a href="/" className="redirect-link">
                    <span className="fa fa-arrow-circle-right"></span>
                  </a>
                </div>
              </div>
            );
          })
        }
      </section>
    );
  }
}

export default SupportBusiness;



// WEBPACK FOOTER //
// ./components/users/sub-view/support-business/SupportBusiness.jsx